import { SiteSetting } from '../components/shared/services/site-settings/site-settings/site-setting';
import { CanMatchFn } from '@angular/router';
import { inject } from '@angular/core';
import {
	SynchronousSiteSettingsService
} from '../components/shared/services/site-settings/site-settings/synchronous-site-settings.service';

export const getMatchOnSiteSettingGuard = (setting: SiteSetting): CanMatchFn => {
	return async () => {
		const siteSettingService = inject(SynchronousSiteSettingsService);

		await siteSettingService.loadSiteSettingData();

		return siteSettingService.getSiteSettingSwitch(setting);
	};
};
